import { createContext, useContext, type ReactNode } from 'react';

// HOW HIGH THE THING YOU ARE OPENING HAS TO SIT, when overlays open on top of overlays.
//
// Every full-screen overlay in this app portals to <body>, so what paints over what is
// decided by z-index alone and not by where the component lives. Fixed numbers work while
// there are two kinds of overlay and stop working at three: a picture zoom sits at 60 so it
// can open over a dialog, and a call badge INSIDE that zoom opened its menu at 50 — behind
// the very backdrop it was pressed on, which looks exactly like a button that does nothing.
//
// So the number is inherited instead. Each overlay reads the layer it was opened from and
// paints ten above it, then offers that to whatever it contains. A badge in a zoom in a
// dialog gets 70 without anybody counting, and the same badge on a plain page gets 60.
//
// It flows by where an element RENDERS, not by who wrote it: `corner` and `details` are
// built by the caller and handed to ImageLightbox, and they read the lightbox's layer
// because that is where they end up in the tree.
const LayerCtx = createContext(50);

export const useLayer = () => useContext(LayerCtx);

// The step between layers. Ten, not one: an overlay that needs a couple of z-indexes of its
// own — a scrim under a frame — has room for them without reaching the next one up.
export const LAYER_STEP = 10;

export function AboveLayer({ z, children }: { z: number; children: ReactNode }) {
  return <LayerCtx.Provider value={z}>{children}</LayerCtx.Provider>;
}
